import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppSettingsService as _appSettings } from './app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class MapsInteractiveService {

  constructor(private _http: HttpClient, private _auth: AuthService) { }

  public model = 'maps';

  getNearClimate(id): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/near-climate/' + id;
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }

  getMeteo10Min(): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/meteo-10min';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }

  getMeteoWeather10Min(): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/meteo-weather-10min';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }

  getMeteoMinsk10Min(): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/meteo-minsk-10min';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }

  getMeteo(): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/meteo';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }

  getMeteoAero(): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/meteo-aero';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }

  getStorm(): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/storm';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }

  getGidro(): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/gidro';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }

  getStaticMapsDate(h): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/static/' + h;
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }
  getStaticMapsDateEGRR(): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/static/egrr';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }
  getStaticMapsDateWRF15(t): Observable<any> {
    const type = t ? `t=${t}` : '';
    const params = `?${type}`;
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/static/wrf15' + params;
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }
  getStaticMapsDateWRF3(t,h): Observable<any> {
    const type = t ? `t=${t}` : '';
    const hour = h ? `h=${h}` : '';
    const params = `?${type}&${hour}`;
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/static/wrf3' + params;
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }
  getStaticMapsDateICON(t,h): Observable<any> {
    const type = t ? `t=${t}` : '';
    const hour = h ? `h=${h}` : '';
    const params = `?${type}&${hour}`;
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/static/icon' + params;
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }
  getStaticFactMaps(): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/static-fact';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }

}
